export class VotingResult {
    agree: number;
    disagree: number;
    abstain: number;
    ignored: number;

    constructor(agree: number, disagree: number, abstain: number, ignored: number) {
        this.agree = agree;
        this.disagree = disagree;
        this.abstain = abstain;
        this.ignored = ignored;
    }
}
